export const PLATFORM_ADMIN_ACCESS_MUTATION_KEY = [
  "platform",
  "admin-access",
  "privileged-write",
] as const;
